import React from 'react'
import { Price, PriceInfoContainer, propConverter } from 'chemistry'
import { extractPriceProps } from 'client/common/components/Card/priceProps'

const TotalBundlePrice = ({ products = [] }) => {
  const { crossedPrice, bigPrice } = products.reduce(
    (acc, p) => {
      const fullPriceProps = propConverter(p)
      const { oldPrice, price, ...rest } = extractPriceProps(fullPriceProps)
      const crossedPrice = oldPrice || price
      const bigPrice = price || crossedPrice

      return {
        crossedPrice: acc.crossedPrice + parseFloat(crossedPrice),
        bigPrice: acc.bigPrice + parseFloat(bigPrice)
      }
    },
    { crossedPrice: 0, bigPrice: 0 }
  )

  return (
    <PriceInfoContainer>
      <PriceInfoContainer.Main>
        <Price oldPrice={bigPrice === crossedPrice ? 0 : crossedPrice} price={bigPrice} />
      </PriceInfoContainer.Main>
    </PriceInfoContainer>
  )
}

export default TotalBundlePrice
